export const termsAndConditions = {
  PEOPLE_TERMS: 'https://storagechasprod01.blob.core.windows.net/termsandcondition/CHAS%20people/CHAS%20People%20Sup.%20Terms%20&%20Conditions%201219.pdf',
  PEOPLE_PRIVACY: 'https://storagechasprod01.blob.core.windows.net/termsandcondition/CHAS%20people/CHAS%20People%20Privacy%20Policy%201219.pdf',
  PLANT_TERMS: 'https://storagechasprod01.blob.core.windows.net/termsandcondition/CHAS%20Plant/CHAS%20Plant%20-%20Terms%20&%20Conditions%2002_20.pdf'
}
